import React from "react";

export default function Signup() {
  return (
    <div className="signup-wrapper">
      <div className="signup-bg">
        <div className="form">
          <table>
            <tbody>
              <tr>
                <td style={{ width: "33.33%" }}>
                  <div className="form-bg">
                    <img src="./Group 1040@2x.png" />
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <p>Create your account. It's free and only takes a minute.</p>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <div>
                    <input placeholder="User Name" type="text" />
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <div>
                    <input type="email" placeholder="Email" />
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <div>
                    <input placeholder="Password" type="password" />
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <div>
                    <input placeholder="Confirm Password" type="password" />
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <div className="terms">
                    <input id="checkid2" type="checkbox" defaultValue="test" />{" "}
                    <label htmlFor="checkid2">
                      I accept the{" "}
                      <a href="https://www.google.com/">Terms of Use</a> &amp;{" "}
                      <a href="https://www.google.com/">Privacy Policy.</a>
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <div>
                    <input type="submit" defaultValue="Register Now" />
                  </div>
                  <p>
                    Already have an account?
                    <a href>login</a>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
